export const catalogList = [
  {
    type: '環境生態資料',
    name: '潮間帶地形',
    link: '/eco-environmental-survey/intertidal-topography',
    description: '整合多時期衛星影像與潮汐資料，重建潮間帶之歷年數值高程模型。',
  },
  {
    type: '環境生態資料',
    name: '底棲生物',
    link: '/eco-environmental-survey/macrobenthos',
    description: '每季於芳苑海空步道周邊與紅樹林疏伐區域進行蟹類與底質調查。',
  },
  {
    type: '環境生態資料',
    name: '水質調查',
    link: '/eco-environmental-survey/water-quality',
    description: '每月進行一次水質調查，包含水溫、酸鹼值、氧化還原電位等資料。',
  },
  {
    type: '環境生態資料',
    name: '鳥類調查',
    link: '/eco-environmental-survey/bird-survey',
    description:
      '介接台灣生物多樣性資訊聯盟(TBIA)彰化縣芳苑鄉鳥類物種出現紀錄公開資料供查詢。',
  },
  {
    type: '環境生態資料',
    name: '空氣品質及氣象',
    link: '/eco-environmental-survey/air-quality',
    description: '介接環境部空氣品質資料及交通部中央氣象署公開資料供查詢。',
  },
  {
    type: '社會調查資料',
    name: '訪談資料',
    link: '/social-survey/interviews',
    description:
      '透過訪談地方權益關係人，將訪談內容去識別化及分類，取得授權同意後公開在地相關議題的觀點。',
  },
  {
    type: '社會調查資料',
    name: '問卷調查',
    link: '/social-survey/questionnaire-survey',
    description:
      '為瞭解芳苑鄉居民對於環境及社會變遷狀況的認知，以地址抽樣方式抽取芳苑鄉沿海家戶，並指派面訪員實地拜訪進行問卷調查。',
  },
  {
    type: '社會調查資料',
    name: '人流監測',
    link: 'https://data.depositar.io/dataset/ltser_changhua_peoplecounting',
    newTab: true,
    description:
      '針對海空步道的人流進行觀測，每月釋出30分鐘一筆的人流監測估算成果。',
  },
  {
    type: '社會調查資料',
    name: '社會經濟資料',
    link: '/social-survey/social-economic-data',
    description: '介接內政部社會經濟資料平台資料及農業部漁業署公開資料供查詢。',
  },
  {
    type: '社會調查資料',
    name: '文史資料',
    link: '/social-survey/local-literature-and-news',
    description: '彙整芳苑鄉相關新聞報導及地方文獻書目供查詢。',
  },
];
